import { describeSdkError, getResponseStatus, readConflictDetail } from "@istari-frontend/shared";

const STALE_LIVE_STATE = "STALE_LIVE_STATE";

/**
 * A compare-live page that failed, carrying the server's reason as its message. The SDK error
 * stays on `cause`, so status-based retry policy still reads the response.
 */
export class CompareLiveError extends Error {
  // The live state moved between pages; the walk must restart from page 1, not retry the page.
  readonly isStaleLiveState: boolean;

  constructor(message: string, isStaleLiveState: boolean, cause: unknown) {
    super(message, { cause });
    this.name = "CompareLiveError";
    this.isStaleLiveState = isStaleLiveState;
  }
}

export async function toCompareLiveError(error: unknown): Promise<CompareLiveError> {
  const status = getResponseStatus(error);
  if (status === undefined) {
    return new CompareLiveError("Could not read the comparison from the server.", false, error);
  }
  const conflict = status === 409 ? await readConflictDetail(error) : undefined;
  const detail = await describeSdkError(error, "The comparison failed.");
  return new CompareLiveError(`${detail} (HTTP ${status})`, conflict?.errorCode === STALE_LIVE_STATE, error);
}
